import { useEffect, useState } from "react";
import { Smartphone, X, Download } from "lucide-react";
import { getAppSettings } from "../lib/appSettings";
import { useLang } from "../context/LangContext";

const KEY = "mw_install_dismissed";

export default function InstallPrompt() {
  const { lang } = useLang();
  const L = (hi, en) => (lang === "hi" ? hi : en);
  const [enabled, setEnabled] = useState(false);
  const [evt, setEvt] = useState(window.__mwInstallEvt || null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  const standalone = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
  const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    getAppSettings().then((data) => setEnabled(!!data.install_prompt)).catch(() => {});
    const h = (e) => { e.preventDefault(); window.__mwInstallEvt = e; setEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  if (!enabled || hidden || standalone || (!evt && !ios)) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  const install = async () => { evt.prompt(); await evt.userChoice; window.__mwInstallEvt = null; close(); };

  return (
    <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-4" data-testid="install-prompt">
      <div className="flex items-center gap-3 rounded-xl border border-cyan-400/30 bg-cyan-500/10 px-4 py-3">
        <Smartphone size={20} className="text-cyan-300 shrink-0" />
        <p className="text-sm text-cyan-50 flex-1">
          {ios
            ? L("फ़ोन में ऐप की तरह जोड़ें: Share बटन दबाएं → \"Add to Home Screen\"", "Install as an app: tap Share → \"Add to Home Screen\"")
            : L("Bam Bam Bhole को फ़ोन में ऐप की तरह इंस्टॉल करें", "Install Bam Bam Bhole on your phone like an app")}
        </p>
        {!ios && evt && (
          <button onClick={install} data-testid="install-app-btn" className="btn-gold rounded-lg px-3 py-1.5 text-xs flex items-center gap-1.5 shrink-0"><Download size={13} /> {L("इंस्टॉल", "Install")}</button>
        )}
        <button onClick={close} data-testid="install-dismiss-btn" className="text-slate-400 hover:text-white shrink-0"><X size={16} /></button>
      </div>
    </div>
  );
}
